import type { ComponentType } from 'react'
import styled from 'styled-components'

import type { TextProps } from '@awazevr/design-system.components.text'
import { Text } from '@awazevr/design-system.components.text'

const StylableText = Text as unknown as ComponentType<TextProps>

export const StyledStarsContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  grid-column: 2;
`

export const StyledGuestRatingValue = styled(StylableText)`
  line-height: 1;
  height: 0.9rem;
  margin-left: 0.25rem;
`
